/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { getAbsoluteValue } from '../../../shared/Utils/Utils';
interface IUtilityCostChangeColumnComponent {
  savingsPercentage: number;
  value: number;
  currencyconverter: string;
}
export const getSavingsBadgeColor = (value: number) => {
  if (value > 0) {
    return '#7eb338';
  } else if (value < 0) {
    return '#f15a4f';
  } else {
    return '#b0b0b0';
  }
};
const UtilityCostChangeColumnComponent = (
  props: IUtilityCostChangeColumnComponent
) => {
  const { savingsPercentage, value, currencyconverter } = props;
  return (
    <span
      style={{ display: 'flex' }}
      className="score-category-meterdata-meter"
    >
      <div
        className="savings-badge"
        style={{
          color: getSavingsBadgeColor(value)
        }}
      >
        {' ' + currencyconverter}
      </div>
      <div
        className="savings-badge"
        style={{
          color: getSavingsBadgeColor(value)
        }}
      >
        {'(' + getAbsoluteValue(savingsPercentage) + '%' + ')'}
      </div>
    </span>
  );
};

export default UtilityCostChangeColumnComponent;
